import actions from "./action_types";
import axios from "axios";
import mutations from "./mutation_types";
export default {
    [actions.PREPARE_GROUP_DATA]: function (store, options) {
        return axios.get('/records/payments/get-group-data', {
            params: options
        })
            .then(response => {
                store.commit(mutations.INIT_GROUP_DATA, response.data);
            })
            .catch(error => console.log(error.message))
    },
    [actions.REFRESH_TITLE_FOR_OPERATIONS]: function (store, options) {
        return axios.get('/records/payments/get-title', {
            params: options
        })
            .then(response => {
                store.commit(mutations.REFRESH_TITLE, response.data);
            })
            .catch(error => console.log(error.message))
    },
    [actions.PREPARE_DEPARTMENT_TRANSFERS_DATA]: function (store, options) {
        return axios.get('/records/get-department-transfer-data', {
            params: options
        })
            .then(response => {
                store.commit(mutations.INIT_GROUP_DATA, response.data);
            })
            .catch(error => console.log(error.message))
    },
    [actions.DESTROY_OPERATION_LOCK]: function (store, options) {
        let promise = axios.post('/destroy-lock', {
                "type": options.type,
                'source_id': options.source_id.join(),
            }
        ).then(response => {
            window.location.href = options.href;
        })
            .catch(error => console.log(error.message));
    },
    [actions.SUBMIT_GROUP_FORM]: function(store, options) {
        let groupData = store.getters.getGroupData;
        let stateToCommit = store.getters.getStateToCommit;

        if(!options.hasOwnProperty('group_id')) throw new Error('groupId is missing from options object');
        let url = '/records/payments/group/' + options.group_id;

        let dataToSubmit = {
            'groupState': groupData,
            'operationsState': stateToCommit,
            'actionType': options.action_type,
            'otherOperations': options.other_operations,
            'operations': options.operations,
        };
        return axios.post(url, dataToSubmit);
    },
    [actions.SAVE_OPERATION]: function(store, options) {
        let groupData = store.getters.getGroupData;
        let url = '/records/payments/group/' + groupData.id+'/new-operation';

        let dataToSubmit = {
            'groupState': groupData,
            'actionType': options.action_type,
            'operation_modal_content': options.operation_modal_content,
            'created_operation': options.created_operation,
            'left_for_split': options.left_for_split,
            'target_department_id' : options.target_department_id,
            'current_url_to_block': options.current_url_to_block,
            'current_route_to_block': options.current_route_to_block
        };
        return axios.post(url, dataToSubmit);
    },
    [actions.STORE_SOURCE_TRANSFER_IN_CASH_REGISTER]: function(store, options) {
        let url = '/records/payments/new-operation-cash-receipt';

        let dataToSubmit = {
            'created_operation': options.created_operation,
            'group_id': options.group_id,
            'action_type': options.action_type,
            'amount': options.amount,
            'current_url_to_block' : options.current_url_to_block
        };
        return axios.post(url, dataToSubmit);
    },

    [actions.SUBMIT_DEPARTMENT_TRANSFERS_FORM]: function(store, options) {
        let url = '/records/store-department-transfer-data/' + options.operation_id;
        let dataToSubmit = {'operationData': options.data_to_submit}
        return axios.post(url, dataToSubmit);
    },
    [actions.REFRESH_GROUP_OPERATION]: function(store, params) {
        return axios.post('/records/payments/get-fresh-operation', params)
    },
    [actions.PREPARE_DOCUMENTS]: function(store, params) {
        return axios.post('/records/payments/open-documents/' + params.contractor_id, params)
    },
    [actions.DELETE_OPERATION]: function(store, params) {
        return axios.delete(params.operation.destroy_url, {headers: {
            'Content-Type': 'text/json'
            }
        })
    },
    [actions.PREVALIDATE_DELETE_OPERATION]: function(store, params) {
        return axios.post(params.operation.prevalidate_url, {headers: {
                'Content-Type': 'text/json'
            }
        })
    },
}
